/* OI: Fallback for mobile locale switcher when Alpine xLocalizationForm fails */
(function(){
  'use strict';

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[data-no-instant]');
    if (!link) return;

    var clickAttr = link.getAttribute('@click') || link.getAttribute('x-on:click') || '';
    var match = clickAttr.match(/submit\(\s*'([^']+)'\s*,\s*'locale_selector'\s*\)/);
    if (!match) return;

    var localeCode = match[1];
    var form = link.closest('form[action*="localization"]');
    if (!form) return;

    var input = form.querySelector('[name="locale_code"]');
    if (!input) return;

    e.preventDefault();
    e.stopPropagation();

    input.value = localeCode;
    form.submit();
  }, true);
})();
